import { Injectable } from '@angular/core';

@Injectable()
export class Utils {
    static isNullOrUndefined(ele: any) {
        return ele === null || ele === undefined ? true : false;
    }
}
